import React, { useEffect, useRef, useState } from 'react';
import { useCmsList } from '../../hooks/useCms';
import { FALLBACK_PARTNERS } from '../../data/cmsFallbacks';
import { useLanguage } from '../../context/LanguageContext';

const PartnersSection = () => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let animationId;
    let scrollPosition = 0;
    const scroll = () => {
      if (!isPaused) {
        scrollPosition += 1.75;
        if (scrollPosition >= scrollContainer.scrollWidth / 2) scrollPosition = 0;
        scrollContainer.scrollLeft = scrollPosition;
      }
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isPaused]);

  const allPartners = useCmsList('/api/cms/partners', FALLBACK_PARTNERS);
  const partners = allPartners.filter((p) => !p.is_sponsor);
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section className="relative py-32 bg-[#F9F9F9]">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-black/10 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-black/50 text-sm font-medium uppercase tracking-[0.3em]">
              {t('trust', { de: 'Vertrauen', en: 'Trust' })}
            </span>
            <div className="h-px w-12 bg-[#D4AF37]" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-black">
            {t('hotelPartners', { de: 'Unsere Hotel-Partner', en: 'Our Hotel Partners' })}
          </h2>
        </div>
      </div>

      {/* White band with scrolling logos */}
      <div className="relative py-8 bg-white">
        {/* Left fade gradient */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        {/* Right fade gradient */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div ref={scrollRef} className="flex gap-20 overflow-x-hidden items-center py-4" style={{ scrollBehavior: 'auto' }}>
          {duplicatedPartners.map((partner, index) => (
            <div key={`${partner.id}-${index}`} className="flex-shrink-0 group">
              <div className="w-56 h-32 flex items-center justify-center px-4">
                <img 
                  src={partner.logo_url} 
                  alt={partner.name} 
                  className="max-w-full max-h-full object-contain opacity-100 group-hover:scale-110 transition-all duration-500" 
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Text below the band */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-xl text-black/60 text-center mt-10">
          {t('trustedBy', { de: 'Vertraut von führenden Hotels in Berlin', en: 'Trusted by leading hotels in Berlin' })}
        </p>
      </div>

    </section>
  );
};

export default PartnersSection;
